<template>
    <div class="pageBox">
        <div class="frame">
            <div class="box nav">
                <span>当前位置：</span>
                <router-link to="/ProductList">在线下单</router-link>
                &nbsp;>&nbsp;
                <span>{{ product.productName }}</span>
            </div>
        </div>
        <div class="frame detailFrame">
            <div class="box detail">
                <div class="detail_top">
                    <div class="imgBox">
                        <img :src="product.productImg" :alt="product.productName">
                    </div>
                    <div class="goodsInfo">
                        <div class="row">
                            <div class="title">{{ product.productName }}</div>
                            <div class="info">服务介绍：{{ product.serviceInfo }}</div>
                            <div class="row2">
                                <div class="row2_item">价格：<span class="red">￥{{ FinalPrice }}</span></div>
                                <div class="like row2_item">收藏：
                                    <img v-if="!isLike"
                                         src="../assets/images/like.png"
                                         @click="addCollect"
                                         alt="收藏"/>
                                    <img v-else
                                         @click="cancel_confirm"
                                         src="../assets/images/like_on.png"
                                         alt="收藏"></div>
                            </div>
                        </div>
                        <div class="goodsSpec row">
                            <div class="item" v-for="(item,index) in params" :key="index">
                                <div class="item_title">{{ item.paramName }}：</div>
                                <div class="optionBox">
                                    <el-checkbox-group v-model="checkedCate"
                                                       :min="params.length"
                                                       @change="handleCheckedCateChange">
                                        <el-checkbox v-for="(uint,ind) in item.values"
                                                     :label="uint"
                                                     :key="ind"
                                                     border
                                                     class="option"
                                                     v-show="uint.paramValue!=''"
                                        >{{
                                                uint.paramValue
                                            }}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>
                            <div class="item">
                                <div class="item_title">数量：</div>
                                <el-input-number
                                    size="medium"
                                    :min="1"
                                    v-model="num"></el-input-number>
                            </div>
                        </div>
                        <div class="selectTips">
                            <span>您已选择：</span>
                            <span v-for="(item,index) in checkedCate" :key="index" v-show="item.paramValue!=''">
                                <span v-show="index>0">，</span>
                                {{ item.paramValue }}
                            </span>
                        </div>
                        <div class="payRow">
                            <div class="addCart btn" @click="addCart">加入购物车</div>
                            <div class="payNow btn hide">立即付款</div>
                        </div>
                    </div>
                </div>
                <div class="detail_bottom" v-html="product.productDetail"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "productDetail",
    data() {
        return {
            isLike: false,
            //控制是否能点
            isLike_allow: true,
            //产品参数列表
            params: [],
            //选中参数列表
            checkedCate: [],
            //选中参数id列表
            checkedCateIds: [],
            num: 1,
            //产品信息
            product: {},
            productId: 0,
            //最终价格
            FinalPrice: 0,
            //收藏id
            collectId: [],
        }
    },
    mounted() {
        this.$store.commit('setNav', 3)
        this.productId = this.$route.params.pId
        this.getFirstServeType(this.$route.params.pId)
    },
    methods: {
        /**
         * 收藏
         */
        likeBtn() {
            if (this.isLike_allow && !this.$noLoginAndRouter()) {
                this.isLike_allow = false
                // let tmp = 0//收藏
                // if (this.isLike) {
                //     //取消
                //     tmp = 1
                //
                // }
                setTimeout(() => {
                    this.isLike_allow = true
                }, 2000)
            }
        },

        /**
         * 选择产品参数
         **/
        handleCheckedCateChange() {
            let tmp = this.checkedCate
            let last_price = this.checkedCate[this.checkedCate.length - 1].price
            let extraMoney = last_price
            let last_id = this.checkedCate[this.checkedCate.length - 1].id
            let last = this.checkedCate[this.checkedCate.length - 1]
            let tmpPid = tmp[tmp.length - 1].paramId
            this.checkedCate = [];
            this.checkedCateIds = [];
            for (let i = 0; i < tmp.length; i++) {
                //实现并列多选
                if (tmpPid != tmp[i].paramId) {
                    this.checkedCate.push(tmp[i])
                    let param = {
                        "productParamValueId": Number(tmp[i].id)
                    }
                    this.checkedCateIds.push(param)
                    extraMoney += tmp[i].price
                }
            }
            this.checkedCate.push(last)
            let param = {
                "productParamValueId": last_id
            }
            this.checkedCateIds.push(param)
            //计算价格
            this.FinalPrice = this.product.price + extraMoney
        },

        /**
         * 获取产品详情
         * @param id 产品id
         */
        getFirstServeType(id) {
            this.$post('/V1/Product/GetProductDetail', {
                id: id
            })
                .then((res) => {
                    // console.log('Detail', res)
                    if (res.success) {
                        this.product = res.response
                        document.title = this.product.productName + this.$suffix
                        //产品参数默认选中第一个
                        let tmp = res.response.params
                        this.checkedCate = []
                        this.checkedCateIds = [];
                        let extraMoney = 0
                        for (let i = 0; i < tmp.length; i++) {
                            if (tmp[i].values.length > 0) {
                                this.checkedCate.push(tmp[i].values[0])
                                let param = {
                                    "productParamValueId": Number(tmp[i].values[0].id)
                                }
                                this.checkedCateIds.push(param)
                                extraMoney += tmp[i].values[0].price
                            }
                        }
                        //过滤空选项的产品参数
                        for (let m = 0; m < tmp.length; m++) {
                            if (tmp[m].values.length > 0) {
                                this.params.push(tmp[m])
                            }
                        }
                        //计算产品价格
                        this.FinalPrice = this.product.price + extraMoney
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
        },

        /**
         * 添加购物车
         */
        addCart() {
            if (!this.$noLoginAndRouter()) {
                this.$post('/V1/ShoppingCart/ModiyShoppingCart', {
                    "userId": Number(this.$store.state.user.userName),
                    "productId": Number(this.productId),
                    "number": this.num,
                    "paramValues": this.checkedCateIds
                }).then((res) => {
                    // console.log('addCart', res)
                    if (res.success) {
                        this.$message.success("加入购物车成功！");
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                }).catch(() => {

                })
            }
        },

        /**
         * 添加收藏
         */
        addCollect() {
            this.isLike_allow = false
            if (!this.$noLoginAndRouter()) {
                this.$post('/V1/Collect/AddCollect', {
                    "id": 0,
                    "userId": Number(this.$store.state.user.userName),
                    "productId": Number(this.productId),
                })
                    .then((res) => {
                        // console.log('addCollect', res)
                        if (res.success) {
                            this.collectId.push(res.response)//收藏id
                            this.$message.success("已收藏！")
                            this.isLike = true
                            setTimeout(() => {
                                this.isLike_allow = true
                            }, 1000)
                        } else {
                            this.$message.error("网络错误，请重试");
                            setTimeout(() => {
                                this.isLike_allow = true
                            }, 1000)
                        }
                    }).catch(() => {
                    setTimeout(() => {
                        this.isLike_allow = true
                    }, 1000)
                })
            } else {
                setTimeout(() => {
                    this.isLike_allow = true
                }, 1000)
            }
        },

        /**
         *确认是否取消收藏
         **/
        cancel_confirm() {
            this.$confirm('即将取消收藏该产品, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning '
            }).then(() => {
                this.cancelCollect()
            }).catch(() => {

            })
        },

        /**
         * 取消收藏
         */
        cancelCollect() {
            this.isLike_allow = false
            if (!this.$noLoginAndRouter()) {
                this.$post('/V1/Collect/DeleteCollect', {
                    ids: this.collectId,
                })
                    .then((res) => {
                        // console.log('cancelCollect', res)
                        if (res.success) {
                            this.$message.success("已取消收藏！")
                            this.isLike = false
                            setTimeout(() => {
                                this.isLike_allow = true
                            }, 1000)
                        } else {
                            this.$message.error("网络错误，请重试");
                            setTimeout(() => {
                                this.isLike_allow = true
                            }, 1000)
                        }
                    }).catch(() => {
                    setTimeout(() => {
                        this.isLike_allow = true
                    }, 1000)
                })
            } else {
                setTimeout(() => {
                    this.isLike_allow = true
                }, 1000)
            }
        }
    }
}
</script>

<style scoped lang="less">
.pageBox {
    display: flex;
    flex-direction: column;

    .frame {
        width: 100%;
        background-color: #f9f9f9;

        .box {
            width: 1210px;
            margin: 0 auto;
        }

        .nav {
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #666666;
            font-size: 16px;
            height: 40px;
            line-height: 40px;

            a {
                color: #666666;
            }
        }
    }

    .detailFrame {
        background-color: white;
        padding: 30px 0px;

        .detail {
            display: flex;
            flex-direction: column;

            .detail_top {
                display: flex;
                flex-direction: row;

                .imgBox {
                    width: 500px;
                    height: 250px;
                    box-shadow: 0 0 5px 0 #cecece;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .goodsInfo {
                    margin-left: 20px;
                    width: 690px;
                    display: flex;
                    flex-direction: column;
                    font-size: 15px;

                    .row {
                        padding: 10px 20px;
                        width: 650px;
                        display: flex;
                        flex-direction: column;
                        color: #666666;
                        background-color: #f9f9f9;
                        margin-bottom: 16px;

                        .title {
                            color: #1f2d5c;
                            font-size: 23px;
                            font-weight: bold;
                            margin-bottom: 5px;
                        }

                        .info {
                            color: #999;
                        }

                        .red {
                            color: red;
                            font-size: 35px;
                        }

                        .row2 {
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;

                            .row2_item {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                            }

                            .like {
                                margin-right: 180px;

                                img {
                                    width: 20px;
                                    height: 20px;
                                    line-height: 20px;
                                    margin-left: 10px;
                                    cursor: pointer;
                                    overflow: hidden;
                                }
                            }
                        }
                    }

                    .goodsSpec {
                        display: flex;
                        flex-direction: column;

                        .item {
                            display: flex;
                            flex-direction: row;
                            margin-top: 20px;

                            .item_title {
                                min-width: 100px;
                            }

                            .optionBox {
                                display: flex;
                                flex-direction: row;
                                flex-wrap: wrap;
                                font-size: 15px;

                                ::v-deep .is-checked {
                                    border-color: #1f2d5c;
                                }

                                ::v-deep .is-checked .el-checkbox__label {
                                    color: #333;
                                }

                                ::v-deep .el-checkbox .el-checkbox__input {
                                    display: none;
                                }
                            }
                        }

                        .item:nth-child(1) {
                            margin-top: 0px;
                        }
                    }

                    .selectTips {
                        margin: 20px 0px;
                    }

                    .payRow {
                        display: flex;
                        flex-direction: row;

                        .btn {
                            height: 48px;
                            line-height: 48px;
                            width: 150px;
                            text-align: center;
                            border: 1px solid #1f2d5c;
                            border-radius: 5px;
                            cursor: pointer;
                        }

                        .addCart {
                            background-color: white;
                            color: #1f2d5c;
                            margin-right: 30px;
                        }

                        .addCart:hover {
                            background-color: #1f2d5c;
                            color: white;
                            box-shadow: 0 0 5px 0 #c9c9c9;
                            transition: .3s;
                        }

                        .payNow {
                            background-color: #1f2d5c;
                            color: white;
                        }
                    }
                }
            }

            .detail_bottom {
                margin-top: 50px;
                width: 100%;
                overflow: hidden;

                * {
                    max-width: 100%;
                }
            }
        }
    }
}

</style>
